var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
import * as React from 'react';
import { cardContentContainerVariants, cardImageVariants, cardVariants } from './campaignCardStyles';
var CampaignCard = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, headerImage = _a.headerImage, layout = _a.layout, _b = _a.testid, testid = _b === void 0 ? 'campaign-card' : _b, title = _a.title, url = _a.url, props = __rest(_a, ["children", "className", "headerImage", "layout", "testid", "title", "url"]);
    return (_jsxs("a", __assign({ "aria-label": title, className: classNameMerge('cursor-pointer hover:scale-[1.03]', cardVariants({ className: className, layout: layout })), "data-testid": testid, href: url, onKeyDown: function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                window.location.href = url;
            }
        }, ref: ref }, props, { children: [headerImage && (_jsx("div", { "aria-label": "".concat(title, " image") || 'Campaign image', className: classNameMerge(cardImageVariants({ layout: layout })), "data-testid": "".concat(testid, "-image"), style: { backgroundImage: "url('".concat(headerImage, "')") } })), _jsx("div", { className: classNameMerge(cardContentContainerVariants({ layout: layout })), "data-testid": "".concat(testid, "-content"), children: children })] })));
});
CampaignCard.displayName = 'CampaignCard';
export { CampaignCard, cardVariants };
